/**
 * @desc: Copied from https://git.perkbox.io/backend-services/identity-v2/blob/master/internal/errorLib/codes.go
 */
enum Tenant {
  TenantNotFoundErr = "PBIDETenantNotFound",
  TenantNotActive = "PBIDETenantNotActive",
  SubdomainNotFound = "PBIDESubdomainNotFound",
  SubdomainAlreadyExists = "PBIDESubdomainAlreadyExists",
  SubdomainCannotBeChanged = "PBIDESubdomainCannotBeChanged",
  SubdomainTooShort = "PBIDESubdomainTooShort",
  SubdomainTooLong = "PBIDESubdomainTooLong",
  SubdomainInvalid = "PBIDESubdomainInvalid",
  PublicNameAlreadyExists = "PBIDEPublicNameAlreadyExists",
  PublicNameTooShort = "PBIDEPublicNameTooShort",
  PublicNameTooLong = "PBIDEPublicNameTooLong",
  PublicNameInvalid = "PBIDEPublicNameInvalid",
  TenantCannotBeChanged = "PBIDETenantCannotBeChanged",
  LocaleInvalid = "PBIDELocaleInvalid"
}

export default Tenant
